"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var ParNewsListCtl = /** @class */ (function (_super) {
    __extends(ParNewsListCtl, _super);
    function ParNewsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_is_published = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_published; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_pprogram_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_id; });
        _this.dk_pprogram_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_title; });
        _this.dk_cms_image_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_image_url; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_date_published2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_published2; });
        _this._errDialog = errDialog;
        return _this;
    }
    ParNewsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    ParNewsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    ParNewsListCtl.prototype.LoadData = function (allBrands, brandsIdList, onDone) {
        var _this = this;
        webAApi_1.ListPProgramNewsByPProgramId.exec({ all_pprograms: allBrands, pprogram_id_list: brandsIdList }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    pprogram_id: resp.list[i].pprogram_id,
                    pprogram_title: resp.list[i].pprogram_title,
                    title: resp.list[i].title,
                    is_published: resp.list[i].is_published,
                    cms_image_url: resp.list[i].cms_image_url,
                    description: resp.list[i].description,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    post_year: resp.list[i].post_year,
                    post_month: resp.list[i].post_month,
                    post_day: resp.list[i].post_day,
                    post_hour: resp.list[i].post_hour,
                    post_minute: resp.list[i].post_minute,
                    post_second: resp.list[i].post_second,
                    date_published2: moment(resp.list[i].post_date_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParNewsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramNews.exec({
            data: {
                pprogram_id: data.pprogram_id,
                title: data.title,
                cms_image_url: data.cms_image_url,
                publish_year: data.publish_year,
                publish_month: data.publish_month,
                publish_day: data.publish_day,
                publish_hour: data.publish_hour,
                publish_minute: data.publish_minute,
                publish_second: data.publish_second,
                is_published: data.is_published,
                description: data.description
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                pprogram_id: data.pprogram_id,
                pprogram_title: resp.pprogram_title,
                title: data.title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                cms_image_url: data.cms_image_url,
                is_published: data.is_published,
                post_year: data.publish_year,
                post_month: data.publish_month,
                post_day: data.publish_day,
                post_hour: data.publish_hour,
                post_minute: data.publish_minute,
                post_second: data.publish_second,
                description: data.description,
                date_published2: moment(resp.publish_date_uts_ms).utc(false)
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParNewsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPProgramNews.exec({
                data: {
                    pprogram_news_id: data.key,
                    title: data.title,
                    cms_image_url: data.cms_image_url,
                    description: data.description,
                    is_published: data.is_published,
                    publish_year: data.publish_year,
                    publish_month: data.publish_month,
                    publish_day: data.publish_day,
                    publish_hour: data.publish_hour,
                    publish_minute: data.publish_minute,
                    publish_second: data.publish_second
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.cms_image_url = data.cms_image_url;
                _tmp.description = data.description;
                _tmp.is_published = data.is_published;
                _tmp.post_year = data.publish_year;
                _tmp.post_month = data.publish_month;
                _tmp.post_day = data.publish_day;
                _tmp.post_hour = data.publish_hour;
                _tmp.post_minute = data.publish_minute;
                _tmp.post_second = data.publish_second;
                _tmp.cms_image_url = data.cms_image_url;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.date_published2 = moment(resp.publish_date_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParNewsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    ParNewsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgramNews.exec({ data: { pprogram_news_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return ParNewsListCtl;
}(BaseController_1.BaseController));
exports.ParNewsListCtl = ParNewsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_news/ctl/ParNewsListCtl.ts
// module id = 1004
// module chunks = 0